// extracted by mini-css-extract-plugin
module.exports = {"con":"Case_con__3W3Vq","title":"Case_title__27fSF","box":"Case_box__3BV11","img":"Case_img__17lcA","name":"Case_name__3L76z"};